export default __webpack_public_path__ + "static/media/saint-malo.d36e1c48.jpg";